import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影',
    desc: '剧情 / 科幻 / 悬疑 · 每周更新上映佳作',
    accent: 'bg-primary-500 text-background-50',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧',
    desc: '热播剧集 / 完结好剧 · 追剧不迷路',
    accent: 'bg-accent-500 text-primary-950',
  },
];

const quickGenres = [
  { label: '科幻', to: '/category/movie?genre=科幻' },
  { label: '悬疑', to: '/category/movie?genre=悬疑' },
  { label: '爱情', to: '/category/tv?genre=爱情' },
  { label: '犯罪', to: '/category/tv?genre=犯罪' },
  { label: '历史', to: '/category/movie?genre=历史' },
  { label: '家庭', to: '/category/tv?genre=家庭' },
];

export default function CategoryEntries() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="font-heading text-lg font-bold text-foreground-950">分类快捷入口</h2>
      <div className="mt-4 flex flex-col gap-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-3 rounded-md border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300 hover:bg-secondary-100 cursor-pointer"
          >
            <span className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md ${entry.accent}`}>
              <i className={`${entry.icon} text-2xl`} aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-heading text-base font-semibold text-foreground-950">
                {entry.title}
              </span>
              <span className="mt-0.5 block truncate font-label text-xs text-foreground-600">
                {entry.desc}
              </span>
            </span>
            <i
              className="ri-arrow-right-s-line text-xl text-foreground-500 transition-transform group-hover:translate-x-1"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>

      <div className="mt-5">
        <span className="font-label text-xs text-foreground-500">按类型浏览</span>
        <div className="mt-3 flex flex-wrap gap-2">
          {quickGenres.map((genre) => (
            <Link
              key={genre.label}
              to={genre.to}
              className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900 transition-colors hover:bg-accent-100 hover:text-accent-900 cursor-pointer"
            >
              {genre.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}